import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { useRef as m, useEffect as l } from "react";
import '../../assets/PromotionBlock.css';const o = {
  "promo-image": "_promo-image_1nlw7_12",
  "promo-image__text": "_promo-image__text_1nlw7_33",
  "promo-copy": "_promo-copy_1nlw7_38",
  "promo-image--animate": "_promo-image--animate_1nlw7_44",
  "promo-copy--animate": "_promo-copy--animate_1nlw7_51",
  "promo-copy__header": "_promo-copy__header_1nlw7_59",
  "promo-copy__description": "_promo-copy__description_1nlw7_64",
  "promo-copy__link": "_promo-copy__link_1nlw7_65"
};
function f({ image: a, promo: r }) {
  const i = m(), n = m(), p = (t, _) => {
    t.forEach((s) => {
      s.isIntersecting && (i.current.classList.add(`${o["promo-copy--animate"]}`), n.current.classList.add(`${o["promo-image--animate"]}`), _.unobserve(n.current));
    });
  };
  return l(() => {
    const t = new IntersectionObserver(p, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    });
    return t.observe(n.current), () => {
      t.disconnect();
    };
  }, []), /* @__PURE__ */ c("promotion-block", { children: [
    /* @__PURE__ */ c("div", { className: o["promo-image"], ref: n, children: [
      /* @__PURE__ */ e("span", { className: o["promo-image__text"], children: a.text }),
      /* @__PURE__ */ e("promo-image", { children: /* @__PURE__ */ e("a", { href: r.href, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ e("img", { src: a.url, alt: a.altText }) }) })
    ] }),
    /* @__PURE__ */ c("div", { className: o["promo-copy"], ref: i, children: [
      /* @__PURE__ */ e("h4", { className: o["promo-copy__header"], children: r.header }),
      /* @__PURE__ */ e("p", { className: o["promo-copy__description"], children: r.description }),
      /* @__PURE__ */ e("a", { className: o["promo-copy__link"], href: r.href, target: "_blank", rel: "noreferrer", children: r.linkText })
    ] })
  ] });
}
export {
  f as PromotionBlock,
  f as default
};
